import { Col, Modal, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { loadUpdateSlaData } from "../../redux/action";
import moment from "moment";

const truncateText = (text, limit) => {
    return text.length > limit ? text.substring(0, 12) + "..." : text;
};

const renderTooltip = (props, text) => (
    <Tooltip {...props}>{text}</Tooltip>
);

const UpdateScoreHistory = (props) => {
    const dispatch = useDispatch();
    const updateSlaData = props?.updateSlaData;
    const loading = props.loading;
    // const [loading, setLoading] = useState(true);
    // const { updateSlaData } = useSelector((state) => state.data);

    // useEffect(() => {
    //     dispatch(loadUpdateSlaData(setLoading));
    // }, [dispatch]);

    const getStatusClass = (status) => {
        switch (status) {
            case "Completed":
                return "complete-status no-dropdown-badge";
            case "In-Progress":
                return "inprogress-status no-dropdown-badge";
            case "Hold":
                return "pending-status no-dropdown-badge";
            case "Cancel":
                return "cancel-status no-dropdown-badge";
            default:
                return "";
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleClose} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Score Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        updateSlaData?.length > 0 ? (
                            updateSlaData.map((sla, index) => (
                                <Row key={index} className='customer-form-fields' style={{ backgroundColor: "rgba(245, 245, 245, 1)", marginBottom: "10px", padding: "10px" }}>
                                    <Col>
                                        <Row>
                                            <Col md={6}>
                                                <div className="view-sla-data score-details-data">
                                                    <label>Department</label>
                                                    <p className="m-0">:</p>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={renderTooltip(null, sla?.DepartmentName)}
                                                    >
                                                        <span>{truncateText(sla?.DepartmentName, 15)}</span>
                                                    </OverlayTrigger>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="view-sla-data score-details-data">
                                                    <label>Achieved %</label>
                                                    <p className="m-0">:</p>
                                                    <span>{sla?.AchievedPercentage}%</span>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <div className="view-sla-data score-details-data">
                                                    <label>Assigned Score</label>
                                                    <p className="m-0">:</p>
                                                    <span>{sla?.AssignedScore}</span>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="view-sla-data score-details-data">
                                                    <label>Reported On</label>
                                                    <p className="m-0">:</p>
                                                    <span>{sla?.ReportedOn}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <div className="view-sla-data score-details-data">
                                                    <label>Status</label>
                                                    <p className="m-0">:</p>
                                                    <span className={`status-badge ${getStatusClass(sla.Status)}`}>{sla?.Status}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            ))
                        ) : (
                            <p>No SLA updates available.</p>
                        )
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleClose} />
                    <SBSaveUpdateBtn btnName="Ok" onClickEffect={props.handleNextStep} />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default UpdateScoreHistory;
